var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"LmActorLabel"},[(_vm.hasSlot)?_c('span',{staticClass:"Text"},[_vm._t("default")],2):_vm._e(),_c('span',{staticClass:"Label",class:_vm.actor.color},[_vm._v(_vm._s(_vm.actor.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }